import React from "react";
import { sectionFrame } from "../../config/site";
import { assets, merchCards } from "../../content/site";
import { SectionHeading } from "../ui/SectionHeading";

export function MerchSection() {
    return (
        <section id="merch" className="px-4 pt-[120px] sm:px-6 max-md:pt-[84px]">
            <div className={sectionFrame}>
                <SectionHeading label="Мерч" title="Мерч конференции" />
                <div className="flex max-w-[1400px] gap-6 max-[639px]:flex-col max-[639px]:gap-3">
                    {merchCards.map((item, index) => (
                        <article
                            key={item.title}
                            className={[
                                "relative h-[826px] overflow-hidden rounded-[40px] border px-[42px] pt-[42px] pb-[22px]",
                                "max-[639px]:w-full max-[639px]:rounded-[24px] max-[639px]:p-5",
                                index === 0
                                    ? "max-[639px]:h-[523px] max-[639px]:overflow-visible"
                                    : "max-[639px]:h-[523px]",
                                item.accent === "green"
                                    ? "w-[800px] border-accent bg-accent text-[#101010]"
                                    : "w-[576px] border-muted bg-[#0d0d0d] text-white",
                            ].join(" ")}
                            aria-label={item.title}
                        >
                            <div className="relative z-10 h-full">
                                <h3 className="mb-6 text-5xl leading-none tracking-[-0.04em] uppercase max-md:text-[30px] max-[639px]:mb-3 max-[639px]:max-w-[220px] max-[639px]:text-[31px] max-[639px]:leading-[1]">
                                    {item.title}
                                </h3>
                                {item.description ? (
                                    <p className="absolute bottom-0 left-0 right-0 m-0 w-full text-[18px] font-medium uppercase leading-[1.24] tracking-[-0.04em] max-[639px]:text-[12px] max-[639px]:leading-[1.24] max-[639px]:tracking-[0]">
                                        {item.description}
                                    </p>
                                ) : null}
                            </div>
                            {index === 0 ? (
                                <div className="pointer-events-none absolute inset-x-0 top-[147px] bottom-[147px] z-0 flex items-center justify-center max-[639px]:left-[7px] max-[639px]:right-[7px] max-[639px]:top-[54px] max-[639px]:bottom-[10px]">
                                    <div
                                        className="absolute h-[450px] w-[450px] rounded-full bg-[rgba(150,234,40,1)] blur-[99.20001220703125px] max-[639px]:blur-[60px] max-[639px]:h-[250px] max-[639px]:w-[250px]"
                                        style={{ transform: "rotate(0.06deg)" }}
                                        aria-hidden="true"
                                    />
                                    <div className="relative z-[1] flex items-center justify-center">
                                        <img
                                            src={item.image}
                                            alt={item.imageAlt}
                                            className="h-auto max-w-full object-contain w-full"
                                            loading="lazy"
                                            decoding="async"
                                        />
                                    </div>
                                </div>
                            ) : (
                                <>
                                    <div className="pointer-events-none absolute left-0 right-0 top-[149px] bottom-[88px] z-0 flex justify-center max-[639px]:left-[42px] max-[639px]:right-[42px] max-[639px]:top-[92px] max-[639px]:bottom-[5px]">
                                        <img
                                            src={item.image}
                                            alt={item.imageAlt}
                                            className="h-auto w-[580px] max-w-full object-contain max-[639px]:w-full"
                                            loading="lazy"
                                            decoding="async"
                                        />
                                    </div>
                                    <div className="pointer-events-none absolute right-[-10px] top-[42px] z-10 h-[128px] w-[172px] max-[639px]:right-[6px] max-[639px]:top-[18px] max-[639px]:w-[92px] max-[639px]:h-auto">
                                        <img
                                            src={assets.merchBirk}
                                            alt=""
                                            className="h-full w-full object-contain drop-shadow-[-3px_4px_7.1px_rgba(0,0,0,0.18)] max-[639px]:h-auto"
                                            loading="lazy"
                                            decoding="async"
                                        />
                                    </div>
                                    <div className="pointer-events-none absolute bottom-[183px] left-[19px] z-10 h-[144px] w-[142px] max-[639px]:bottom-[112px] max-[639px]:left-[10px] max-[639px]:w-[84px] max-[639px]:h-auto">
                                        <img
                                            src={assets.merchCard}
                                            alt=""
                                            className="h-full w-full object-contain drop-shadow-[-3px_4px_7.1px_rgba(0,0,0,0.18)] max-[639px]:h-auto"
                                            loading="lazy"
                                            decoding="async"
                                        />
                                    </div>
                                </>
                            )}
                            {index === 0 ? (
                                <div
                                    className="pointer-events-none absolute bottom-[-52px] left-[-72px] z-20 hidden w-[236px] max-[639px]:block"
                                    aria-hidden="true"
                                >
                                    <img
                                        src={assets.cube}
                                        alt=""
                                        className="drop-shadow-[0_24px_36px_rgba(255,255,255,0.12)]"
                                        loading="lazy"
                                        decoding="async"
                                    />
                                </div>
                            ) : null}
                        </article>
                    ))}
                </div>
                <div
                    className="pointer-events-none relative ml-[-180px] mt-[-270px] w-[400px] max-[639px]:hidden"
                    aria-hidden="true"
                >
                    <img
                        src={assets.cube}
                        alt=""
                        className="drop-shadow-[0_24px_36px_rgba(255,255,255,0.12)]"
                        loading="lazy"
                        decoding="async"
                    />
                </div>
            </div>
        </section>
    );
}
